import axios, { type AxiosError } from 'axios';

const PASSWORD_REQUIRED_SNIPPET = 'şifre tanımlı değil';

export function isPasswordRequiredError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false;
  const status = error.response?.status;
  const message =
    (error.response?.data as { message?: string } | undefined)?.message?.toLowerCase() ?? '';
  return status === 412 || message.includes(PASSWORD_REQUIRED_SNIPPET);
}

export const PASSWORD_REQUIRED_USER_MESSAGE =
  'Google ile giriş yaptığınız için hesabınızda henüz şifre yok. Telefon veya şifre işlemleri için önce şifre oluşturmalısınız.';
